import React, {memo} from "react";
import DeviceRadioButtonChecked from "../../assets/svg/DeviceRadioButtonChecked";
import DeviceRadioButtonUnchecked from "../../assets/svg/DeviceRadioButtonUnchecked";

const AllowedDeviceSelectionItem = memo(({ title, message, active, onClick }) => (
  <div
    className={`selection-item${active ? ' active' : ''}`}
    onClick={onClick}
    tabIndex={0}
    role="radio"
    aria-checked={active}
    style={{
      height: '100%',
      alignItems: 'flex-start',
    }}
  >
    <div className="selection-content">
      <div className="row-center">
        {active ? <DeviceRadioButtonChecked /> : <DeviceRadioButtonUnchecked />}
        <span className="selection-title">{title}</span>
      </div>
      <div className="row-center">
        <span className="selection-message">{message}</span>
      </div>
    </div>
  </div>
));

export default AllowedDeviceSelectionItem;
